import React from 'react';

// Instagram logo: brand-gradient rounded square with a clear white camera outline,
// lens, and shutter dot. Proportions tuned to read well even at small sizes.
export function InstagramIcon({ className = '', size }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="ig-grad" cx="30%" cy="107%" r="150%">
          <stop offset="0%" stopColor="#fdf497" />
          <stop offset="5%" stopColor="#fdf497" />
          <stop offset="45%" stopColor="#fd5949" />
          <stop offset="60%" stopColor="#d6249f" />
          <stop offset="90%" stopColor="#285AEB" />
        </radialGradient>
      </defs>
      <rect x="0.5" y="0.5" width="23" height="23" rx="6.5" fill="url(#ig-grad)" />
      <rect x="4.6" y="4.6" width="14.8" height="14.8" rx="4.6" fill="none" stroke="#FFFFFF" strokeWidth="1.9" />
      <circle cx="12" cy="12" r="3.9" fill="none" stroke="#FFFFFF" strokeWidth="1.9" />
      <circle cx="16.6" cy="7.4" r="1.15" fill="#FFFFFF" />
    </svg>
  );
}
